@if (!isLoading) {
  <div class="vessel-tag-container">
    <div class="vessel-tag">
      <div class="tag-header">VESSEL ID TAG</div>
      <div class="tag-id">{{ Vessel.VesselTag }}</div>
      <div class="tag-body">
        <div class="tag-row">
        <span class="tag-label">Dept:</span>
        <span class="tag-value">{{ Vessel.DeptName }}</span>
      </div>
      <div class="tag-row">
          <span class="tag-label">Name:</span>
          <span class="tag-value">{{ Vessel.VesselName }}</span>
        </div>
        <div class="tag-row">
          <span class="tag-label">Type:</span>
          <span class="tag-value">{{ Vessel.VesselType }}</span>
        </div>
        <div class="tag-row">
          <span class="tag-label">Capacity:</span>
          <span class="tag-value">{{ Vessel.TotalCapacityKg }} Kg (Working: {{ Vessel.WorkingCapacityKg }} Kg)</span>
        </div>
        <div class="tag-row">
          <span class="tag-label">Tare:</span>
          <span class="tag-value">@if (Vessel.TareWeightKg) { {{ Vessel.TareWeightKg | number:'1.2-2' }} Kg (empty) } @else { Not Provided }</span>
        </div>
        <div class="tag-row">
          <span class="tag-label">Size:</span>
          <span class="tag-value">{{ Vessel.VesselSize }}</span>
        </div>
        <div class="tag-row">
          <span class="tag-label">Material:</span>
          <span class="tag-value">{{ Vessel.VesselMaterial }}</span>
        </div>
      </div>
      <div class="tag-footer">
        <div class="company-name">{{ CompanyName }}</div>
      </div>
    </div>
  </div>
}
